let getModalActivity = function(val){
	if(this.getModalActivity.saved) {
		this.getAds();
		this.getModalActivity.saved = false;
		this.$store.commit('core/setModalActivity', this.getModalActivity);
	}
};
export default getModalActivity;
